import { IDepartments } from '../../../../../interface/interfaces';

export const getInOutDepartments = (departmentNetwork: IDepartments[], rootDepartment: IDepartments, Type: 'In' | 'Out') => {
    const connectionDepartment = departmentNetwork.filter((item: IDepartments) => rootDepartment[Type].includes(item.DepartmentId)).map((item: IDepartments) => ({ ...item, Type }));
    return connectionDepartment;
};
